import _defineProperty from "/app/node_modules/.pnpm/next@12.3.3_@babel+core@7.14.3_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useState } from 'react';
import { Badge, Button, DeprecatedIcon } from '@vinted/web-ui';
import OutsideClick from 'components/OutsideClick';
import { NOTIFICATIONS_URL } from 'constants/routes';
import { UiState } from 'constants/ui';
import useFetchInboxNotifications from 'hooks/useFetchInboxNotifications';
import useTranslate from 'hooks/useTranslate';
import useBrazeControlCardImpressionLogging from 'libs/common/braze/hooks/useBrazeControlCardImpressionLogging';
import HeaderNotificationDropdown from './HeaderNotificationDropdown';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_NOTIFICATIONS_AMOUNT = 5;
const MAX_BADGE_COUNT = 99;

const HeaderNotifications = _ref => {
  let {
    unreadNotificationCount = 0,
    onNotificationsFetched
  } = _ref;
  const translate = useTranslate('header.a11y.notifications');
  const {
    0: isDropdownVisible,
    1: setIsDropdownVisible
  } = useState(false);
  const {
    notifications,
    controlNotificationCards,
    setNotifications,
    brazeNotificationCount,
    uiState,
    setUiState
  } = useFetchInboxNotifications();
  useBrazeControlCardImpressionLogging(isDropdownVisible && controlNotificationCards ? controlNotificationCards.map(_ref2 => {
    let {
      id
    } = _ref2;
    return id;
  }) : []);
  useEffect(() => {
    if (uiState === UiState.Success) onNotificationsFetched === null || onNotificationsFetched === void 0 ? void 0 : onNotificationsFetched();
  }, [uiState, onNotificationsFetched]);

  function handleDropdownVisibilityChange() {
    const wasVisible = isDropdownVisible;

    if (wasVisible) {
      setNotifications(items => items.map(item => item.isViewed ? item : _objectSpread(_objectSpread({}, item), {}, {
        isViewed: true
      })));
    }

    if (!wasVisible && (uiState === UiState.Idle || uiState === UiState.Failure)) {
      // TODO: [KK-1444] refactor to fetch notifications explicitly
      setUiState(UiState.Pending);
    }

    setIsDropdownVisible(!wasVisible);
  }

  function handleClick(event) {
    event.preventDefault();
    handleDropdownVisibilityChange();
  }

  function handleOutsideClick() {
    if (!isDropdownVisible) return;
    handleDropdownVisibilityChange();
  }

  const mergedNotificationCount = unreadNotificationCount + brazeNotificationCount;
  const badgeNotificationCount = Math.min(mergedNotificationCount, MAX_BADGE_COUNT);
  const notificationSuffix = mergedNotificationCount > MAX_BADGE_COUNT ? '+' : '';
  return /*#__PURE__*/_jsxs(OutsideClick, {
    onOutsideClick: handleOutsideClick,
    children: [/*#__PURE__*/_jsx(Button, {
      testId: "header-notification-button",
      onClick: handleClick,
      styling: Button.Styling.Flat,
      deprecatedIcon: /*#__PURE__*/_jsx(DeprecatedIcon, {
        name: "bell",
        size: DeprecatedIcon.Size.Regular,
        color: DeprecatedIcon.Color.GreyscaleLevel4,
        aria: {
          'aria-label': mergedNotificationCount ? translate('new_notifications', {
            count: mergedNotificationCount
          }) : translate('notifications')
        }
      }),
      url: NOTIFICATIONS_URL
    }), !!badgeNotificationCount && /*#__PURE__*/_jsx("div", {
      className: "user-actions__notification",
      "data-testid": "header-notifications-badge",
      children: /*#__PURE__*/_jsx(Badge, {
        content: /*#__PURE__*/_jsx("span", {
          "aria-hidden": "true",
          children: "".concat(badgeNotificationCount).concat(notificationSuffix)
        }),
        theme: "warning"
      })
    }), isDropdownVisible && /*#__PURE__*/_jsx("div", {
      className: "header-notification-dropdown",
      "data-testid": "header-notification-dropdown",
      children: /*#__PURE__*/_jsx(HeaderNotificationDropdown, {
        isLoading: uiState === UiState.Pending,
        notifications: notifications.slice(0, MAX_NOTIFICATIONS_AMOUNT)
      })
    })]
  });
};

export default HeaderNotifications;